import { getDoc, updateDoc } from 'firebase/firestore';
import { getDownloadURL, ref, uploadBytes } from 'firebase/storage';
import { useState } from 'react';
import { storage } from '../../../services/firebase-config';
import InputFileImage from '../../Form/InputFileImage';
import AlertModal from '../../Layout/AlertModal';
import Loading from '../../Loading';
import styles from './styles.module.css';

export default function ModalUpdateHomeBanner({ updateData, update, setModalVisible, docRef }) {

    const [alertModal, setAlertModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [alertModalTitle, setAlertModalTitle] = useState('Erro');
    const [alertModalMessage, setAlertModalMessage] = useState('mensagem de erro');

    const [fileImage, setFileImage] = useState('');

    async function saveBannerImage(event) {
        event.preventDefault();
        setIsLoading(true);
        let imageUrl = '';
        console.log(fileImage);
        if (fileImage.name) {
            const storageImageRef = ref(storage, `images/home/${fileImage.name}`);
            await uploadBytes(storageImageRef, fileImage);
            imageUrl = await getDownloadURL(storageImageRef);
        }

        const data = await getDoc(docRef);
        const docData = await data.data();
        docData.home.url = imageUrl;
        await updateDoc(docRef, docData);

        setIsLoading(false);
        updateData();
        setModalVisible(false);
    }

    return (
        <div className={styles.fixed}>
            <div className={styles.modalContainer}>
                {alertModal && <AlertModal title={alertModalTitle} message={alertModalMessage} />}


                <div className={styles.modalCard}>
                    {isLoading && <Loading />}
                    <h2>Alterar banner pagina Home</h2>
                    <form >
                        <div className={styles.modalCard__formFields}>
                            <div className={styles.formFields__column}>
                                <InputFileImage value={fileImage} setValue={setFileImage} bookData={fileImage} />
                            </div>


                        </div>
                        <div className={styles.buttonsContainer}>
                            <button onClick={() => { setModalVisible(false) }} className={styles.modalCard__closeButton} >Fechar</button>

                            <button onClick={(event) => { saveBannerImage(event); }} className={styles.modalCard__saveButton}>Alterar</button>

                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}